import { Eye, EyeOff } from "lucide-react";

type InputPasswordEyeProps = {
  showPassword: boolean
  setShowPassword: (showPassword: boolean) => void
};

export const InputPasswordEye = ({ showPassword, setShowPassword }: InputPasswordEyeProps) => (
  <button
    type="button"
    aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
    className="absolute right-3 top-2 bottom-0 transform cursor-pointer"
    onClick={() => setShowPassword(!showPassword)}
  >
    {showPassword
      ? <EyeOff className="h-4 w-4 text-gray-500" />
      : <Eye className="h-4 w-4 text-gray-500" />}
  </button>
);
